import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { apiGet } from '../../../../api/queries/apiGet';
import { API_BASE_URL } from '../constants/consts';
import type { QueryFilters } from '../types';
import { universalMFAQueryKeys } from '../constants/queryKeys';
import { MfaResponse } from '../../types';
import { buildUniversalMfaQueryParams } from '../constants/utils';

const END_POINT = '/metric/mfaResponse';

type MfaResponseDto = MfaResponse;

const convertMfaResponseDtoToMfaResponse = (mfaResponseDto: MfaResponseDto): MfaResponse => {
    return mfaResponseDto;
};

const fetchMfaResponse = async (filters: QueryFilters) => {
    const data = await apiGet<MfaResponseDto>(`${API_BASE_URL}${END_POINT}`, buildUniversalMfaQueryParams(filters));

    return data;
};

export const useMfaResponse = (filters: QueryFilters): UseQueryResult<MfaResponse> => {
    return useQuery({
        queryKey: universalMFAQueryKeys.mfaResponse(filters),
        queryFn: () => fetchMfaResponse(filters),
        select: convertMfaResponseDtoToMfaResponse
    });
};
